import api from '@/api'
import TaskSearchRequest from '@/model/task/TaskSearchRequest'
import TaskRequest from '@/model/task/TaskRequest'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllTasks(actions, { filter, pagination, sort }) {
      return api.base()
        .post('/tasks/get/all',
          TaskSearchRequest({ ...(filter || {}), pagination, sort })
        )
        .then(response => ({
          data: response.data.data,
          pagination: {
            page: response.data.metadata.page,
            pages: response.data.metadata.pages,
            total: response.data.metadata.total,
          },
          sort: response.data.metadata.sort,
        }))
    },
    getTaskById(actions, id) {
      return api.base()
        .get('/tasks/id/' + id)
        .then(response => response.data.data)
    },
    createTask(actions, { task }) {
      return api.base()
        .post('/tasks/add', TaskRequest(task))
        .then(response => response.data.data)
    },
    updateTask(actions, { id, task }) {
      return api.base()
        .post('/tasks/update/' + id, TaskRequest(task))
        .then(response => response.data.data)
    },
    changeTaskStatus(actions, { id, status }) {
      return api.base()
        .post('/tasks/update/status/' + id + '?status=' + status)
        .then(response => response.data.data)
    },
    deleteTask(actions, id) {
      return api.base()
        .post('/tasks/delete/' + id)
        .then(response => response.data.data)
    },
    addTaskComment(actions, { id, message }) {
      return api.base()
        .post('/tasks/comment/' + id + '/json', { message })
        .then(response => response.data.data)
    },
    getSuggestedAssignees(actions, orgId) {
      return api.base()
        .get('/tasks/org/' + orgId + '/suggested-assignee')
        .then(response => response.data.data)
    },
    getMyOpenTaskCount() {
      return api.base()
        .get('/tasks/my/open-count')
        .then(response => response.data.data)
    },
    // Clients behind a REVIEW_CLIENT_REPORT task — authorized by task ownership
    // (does NOT require the dashboard's MONETARY_REPORT_READ permission).
    getTaskReportClients(actions, { id, page, size }) {
      return api.base()
        .get('/tasks/' + id + '/report-clients?page=' + (page || 1) + '&size=' + (size || 50))
        .then(response => ({
          data: response.data.data,
          metadata: response.data.metadata || {},
        }))
    },
  },
}
